import { render, staticRenderFns } from "./SelectionBox.vue?vue&type=template&id=52e6427c&scoped=true&"
import script from "./SelectionBox.vue?vue&type=script&lang=ts&"
export * from "./SelectionBox.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionBox.vue?vue&type=style&index=0&id=52e6427c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6427c",
  null
  
)

export default component.exports